import {
  faFileAlt,
  faScrewdriverWrench,
  faUser,
  faCalendar,
  faCheck,
  faFileContract,
  faMoneyBill,
  faUserAstronaut,
  faFileInvoice,
  faBuilding,
} from '@fortawesome/free-solid-svg-icons'
import createField from '../../../utils/factory/createField'

export const billingFields = [
  {
    section: 'Informações do Faturamento',
    fields: [
      createField({
        id: 'billing.bill_type',
        label: 'Tipo de Faturamento',
        placeholder: 'Selecione o tipo de faturamento',
        type: 'select',
        icon: faFileInvoice,
      }),
      createField({
        id: 'billing.organization_id',
        label: 'Organização',
        placeholder: 'Selecione a organização',
        type: 'select',
        icon: faBuilding,
      }),
      createField({
        id: 'billing.customer_id',
        label: 'Cliente',
        placeholder: 'Selecione o cliente',
        type: 'select',
        icon: faUser,
        isClearable: true,
      }),
      createField({
        id: 'billing.contract_id',
        label: 'Contrato',
        placeholder: 'Selecione o contrato do cliente',
        type: 'select',
        icon: faFileContract,
        isClearable: true,
      }),
      createField({
        id: 'billing.number',
        label: 'Número da Nota Fiscal',
        placeholder: 'Digite o número da nota fiscal',
        type: 'text',
        icon: faFileInvoice,
        fullWidth: true,
      }),
      createField({
        id: 'billing.start_date',
        label: 'Data de inicio do faturamento',
        placeholder: 'Selecione a data de competência',
        type: 'date',
        icon: faCalendar,
      }),
      createField({
        id: 'billing.end_date',
        label: 'Data de fim do faturamento',
        placeholder: 'Selecione a data de fim do faturamento',
        type: 'date',
        icon: faCalendar,
      }),
    ],
  },
]

export const editBillingFields = [
  {
    section: 'Informações do Faturamento',
    fields: [
      createField({
        id: 'billing.bill_type',
        label: 'Tipo de Faturamento',
        placeholder: 'Selecione o tipo de faturamento',
        type: 'select',
        icon: faFileInvoice,
      }),
      createField({
        id: 'billing.organization_id',
        label: 'Organização',
        placeholder: 'Selecione a organização',
        type: 'select',
        icon: faBuilding,
      }),
      createField({
        id: 'billing.customer_id',
        label: 'Cliente',
        placeholder: 'Selecione o cliente',
        type: 'select',
        icon: faUser,
        isClearable: true,
      }),
      createField({
        id: 'billing.contract_id',
        label: 'Contrato',
        placeholder: 'Selecione o contrato do cliente',
        type: 'select',
        icon: faFileContract,
        isClearable: true,
      }),
      createField({
        id: 'billing.number',
        label: 'Número da Nota Fiscal',
        placeholder: 'Digite o número da nota fiscal',
        type: 'text',
        icon: faFileInvoice,
        fullWidth: true,
      }),
      createField({
        id: 'billing.start_date',
        label: 'Data de inicio do faturamento',
        placeholder: 'Selecione a data de competência',
        type: 'date',
        icon: faCalendar,
      }),
      createField({
        id: 'billing.end_date',
        label: 'Data de fim do faturamento',
        placeholder: 'Selecione a data de fim do faturamento',
        type: 'date',
        icon: faCalendar,
      }),
    ],
  },
]

export const detailsBillingFields = [
  {
    section: 'Informações do Faturamento',
    fields: [
      createField({
        id: 'billing.organization',
        label: 'Organização',
        placeholder: 'Digite o nome da organização',
        type: 'text',
        icon: faBuilding,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'billing.number',
        label: 'Número da Nota Fiscal',
        placeholder: 'Digite o número da nota fiscal',
        type: 'text',
        icon: faFileAlt,
        fullWidth: true,
        disabled: true,
      }),
      createField({
        id: 'billing.contract',
        label: 'Contrato',
        placeholder: 'Informe o contrato',
        type: 'text',
        icon: faFileContract,
        disabled: true,
      }),
      createField({
        id: 'billing.customer',
        label: 'Cliente',
        placeholder: 'Informe o cliente',
        type: 'text',
        icon: faUser,
        disabled: true,
      }),
      createField({
        id: 'billing.created_by',
        label: 'Criador por',
        placeholder: 'Informe quem criou',
        type: 'text',
        icon: faUserAstronaut,
        disabled: true,
      }),
      createField({
        id: 'billing.start_date',
        label: 'Data do inicio do faturamento',
        placeholder: 'Selecione a data de inicio do faturamento',
        type: 'text',
        icon: faCalendar,
        disabled: true,
      }),
      createField({
        id: 'billing.end_date',
        label: 'Data de fim do faturamento',
        placeholder: 'Selecione a data de fim do faturamento',
        type: 'text',
        icon: faCalendar,
        disabled: true,
      }),
      createField({
        id: 'billing.status',
        label: 'Status',
        placeholder: 'Informe o status do faturamento',
        type: 'text',
        icon: faCheck,
        disabled: true,
      }),
    ],
  },
  {
    section: 'Itens Faturados',
    array: true,
    fields: [
      createField({
        id: 'items.alias',
        label: 'Item',
        placeholder: 'Selecione o item',
        type: 'text',
        disabled: true,
      }),
      createField({
        id: 'items.description',
        label: 'Descrição',
        type: 'text',
        placeholder: 'Selecione o equipamento',
        icon: faScrewdriverWrench,
        disabled: true,
      }),
      createField({
        id: 'items.quantity',
        label: 'Quantidade',
        type: 'text',
        placeholder: 'Selecione a quantidade',
        icon: faScrewdriverWrench,
        disabled: true,
      }),
      createField({
        id: 'items.price',
        label: 'Preço',
        type: 'number',
        placeholder: 'Digite o preço cobrado pelo equipamento',
        icon: faMoneyBill,
        isNumericFormat: true,
        disabled: true,
      }),
    ],
  },
]
